<template>
  <div class="modal-box" v-if="showModal" @click.self="isShow">
    <div class="content-box" :style="style">
      <div class="title">当前点位监控</div>
      <div class="title sub-title" v-for="item in itemData.cameraList" :key="item.id" @click="openPlayer(item.cameraIndexCode)">
        <img src="../../assets/camera.png">
        <span>{{item.location}}</span>
      </div>
      <div id="item_palyer" v-if="isOpen"></div>
    </div>
  </div>
</template>

<script>
import { getVideoUrl } from '@/api/home'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    x: {
      type: String,
      required: true
    },
    y: {
      type: String,
      required: true
    },
    itemData: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      style: {
        top: 0,
        left: 0
      },
      player: null,
      palyerId: '',
      isOpen: false
    }
  },
  watch: {
    show (value) {
      this.showModal = value
      this.isOpen = false
      // if (value) {
      //   this.$nextTick(() => {
      //     this.createPlayer()
      //     this.urlData(this.code)
      //   })
      // } else {
      //   this.player = null
      // }
    },
    x (value) {
      this.style.left = value
    },
    y (value) {
      this.style.top = value
    },
    code: {
      // handler(value) {
      //   if (value) {
      //     this.$nextTick(() => {
      //       this.urlData(value)
      //     })
      //   }
      // },
      // immediate: true
    }
  },
  created () {
    // this.palyerId = 'p' + new Date().getTime()
  },
  beforeDestroy () {
    console.log('~~~~~销毁播放器了')
  },
  mounted () {

    // this.init()
    // this.urlData(this.code)
  },
  updated () {
    const w = 400
    const h = 300
    if (w + parseInt(this.x) > window.innerWidth) {
      this.style.left = parseInt(this.x) - w + 'px'
    }
    if (h + parseInt(this.y) > window.innerHeight) {
      this.style.top = parseInt(this.y) - h + 'px'
    }
  },
  methods: {
    isShow () {
      this.showModal = false
      this.$emit('showChange', this.showModal)
    },
    openPlayer (code) {
      this.isOpen = true
      this.init()
      this.$nextTick(() => {
        this.createPlayer()
        this.urlData(code)
      })
    },
    init () {
      window.addEventListener('resize', () => {
        if (this.player) {
          this.player.JS_Resize()
        }
      })
    },
    createPlayer () {
      this.player = new window.JSPlugin({
        szId: 'item_palyer',
        szBasePath: '../../../public',
        iMaxSplit: 1,
        iCurrentSplit: 1,
        openDebug: false,
        oStyle: {
          borderSelect: '#FFCC00'
        }
      })
    },
    playVideo (playURL, mode, index) {
      this.player.JS_Play(playURL, { playURL, mode }, index).then(
        () => {
          console.log('realplay success')
        },
        (e) => {
          console.error(e)
        }
      )
    },
    urlData (code) {
      getVideoUrl(code).then((res) => {
        if (res.code === 200) {
          this.playVideo(res.data, 'mse', 0)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: auto;
  .content-box {
    position: absolute;
    width: 300px;
    min-height: 200px;
    padding: 10px;
    border-radius: 8px;
    background: rgba(24, 47, 86, .8);
    pointer-events: auto;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      font-size: 22px;
      font-weight: bolder;
      color: #6EE1FA;
    }
    .sub-title {
      cursor: pointer;
      font-size: 20px;
      font-weight: normal;
      padding-top: 0;
      display: flex;
      justify-content: flex-start;
      pointer-events: auto;
      color: #fff;
      img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
    }
    #item_palyer {
      position: absolute;
      width: 400px;
      height: 300px;
      top: 0;
      left: 300px;
      background: rgba(0, 0, 0, .4);
      border: 1px solid #6EE1FA;
    }
  }
}
</style>
